(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-topic-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.detailshopTopicFilter) return;
    window.detailshopTopicFilter = true;

    const terms = {
      autoshampoo: {
        neutral: ['ph-neutraal', 'ph neutraal', 'ph-neutral', 'ph neutral'], acidic: ['zure shampoo', 'zure autoshampoo', 'zuur shampoo', 'acidic shampoo'], alkaline: ['alkalisch', 'alkaline', 'ontvettende shampoo', 'ontvettende snowfoam', 'degreasing shampoo'], protective: ['wash & coat', 'wash and coat', 'ceramic wash', 'ceramic effect shampoo', 'ceramische sio', 'shampoo & wax', 'shampoo met wax', 'verzegelende shampoo', 'sealant shampoo', 'waterafstotende shampoo'], rinseless: ['rinseless', 'zonder naspoelen', 'wassen zonder water', 'waterless wash'], matte: []
      },
      snowfoam: {
        one: ['ph-neutraal', 'ph neutraal', 'ph-neutral', 'ph neutral'], two: ['alkalisch', 'alkaline', 'ontvettend', 'degreasing'], three: ['coating', 'ceramic', 'keramisch', 'wax safe', 'sealant safe'], four: ['concentraat', 'concentrate', 'geconcentreerd', 'dilution', 'snowfoam', 'snow foam', 'pre wash', 'voorwas'], matte: []
      },
      velgenreiniger: {
        one: ['ph-neutraal', 'ph neutraal', 'ph-neutral', 'ph neutral', 'safe wheel'], two: ['iron', 'ijzer', 'vliegroest', 'fallout', 'kleurreactie', 'remstof'], three: ['alkalisch', 'alkaline', 'acid', 'zuur', 'krachtig', 'heavy duty'], four: ['concentraat', 'concentrate', 'geconcentreerd']
      },
      coating: {
        one: ['keramisch', 'ceramic', 'quartz', 'graphene', 'coating'], two: ['spraycoating', 'spray coating', 'spray coat'], three: ['glascoating', 'glass coating', 'velgcoating', 'wheel coating', 'trim coating', 'plastic coating', 'ledercoating', 'leather coating', 'textile coating'], four: ['easy coat', 'easy coating', 'lite coating', 'one coating', 'beginner'], paint: ['lak', 'paint', 'autolak', 'lakcoating', 'body coat', 'body coating'], glass: ['glas', 'glass', 'ruit', 'ruiten', 'koplamp', 'glaco', 'windshield'], plastic: ['kunststof', 'plastic', 'trim', 'bumper', 'polycarbonaat'], wheel: ['velg', 'wheel', 'dlux']
      },
      polijstmachines: {
        one: ['excenter', 'dual action', 'orbital', ' da ', 'd.a.'], two: ['roterend', 'rotary', 'rotatie', 'rotation'], three: ['mini', 'nano', 'compact', '75mm', '30mm'], four: ['polijstset', 'polisher set', 'polishing set', 'machine set', 'kit']
      },
      'polijstmachine-sets': {
        one: ['polijstset', 'polijstmachine set', 'startset', 'complete polijstset', 'polishing kit'], two: ['mini', 'compact', 'evo mini', 'precisie'], three: ['polijstpasta', '3-staps', 'compound', 'pasta'], four: ['professioneel', 'professional', 'terminator', 't2000', 't4500', 'rotary']
      },
      polijstmiddelen: {
        one: ['heavy cut', 'compound', 'cutting compound', 'h9', 'h8'], two: ['one step', 'one-step', 'all in one', 'all-in-one', 'aio', 'medium cut', 'cut & finish', 'cut and finish'], three: ['finishing', 'finish polish', 'anti hologram', 'anti-hologram', 'm3'], four: ['handpolish', 'hand polish', 'handmatig polijsten']
      },
      'quick-detailer': {
        one: ['quick detailer', 'quick-detailer', 'detail spray', 'detailer spray', 'showroom shine'], two: ['waterless', 'waterless wash', 'rinseless'], three: ['ceramic detailer', 'keramisch', 'sio2', 'si02', 'ceramic spray'], four: ['clay lube', 'glijmiddel', 'lubricant', 'drying aid', 'matte', 'mat', 'folie', 'wrap', 'vinyl', 'wrapped']
      },
      'klei-kleismeermiddel': {
        one: ['clay bar', 'klei', 'detailing clay'], two: ['clay mitt', 'klei mitt', 'klei doek'], three: ['clay lubricant', 'kleismeermiddel', 'clay lube'], four: ['clay kit', 'kleiset', 'decontamination kit']
      },
      lakontvetters: {
        one: ['panel wipe', 'panelwipe', 'lakontvetter', 'paint prep', 'panel prep', 'pre coat'], two: ['ipa', 'isopropyl', 'alcohol', 'panel prep', 'pre coat', 'coating voorbereiding', 'coating prep'], three: ['tar remover', 'teerverwijderaar', 'adhesive', 'ontvettende', 'degreasing', 'snowfoam', 'shampoo', 'allesreiniger', 'apc'], four: ['degreaser', 'ontvetter', 'pre coating', 'coating prep']
      },
      'onderhoud-bescherming': {
        one: ['spray sealant', 'sealant', 'verzegeling', 'quick wax', 'wax', 'maintenance spray', 'onderhoudsspray', 'protectant'], two: ['ceramic topper', 'ceramic maintenance', 'coating onderhoud', 'sio2', 'ceramic', 'keramisch', 'coating'], three: ['interior protect', 'interieur bescherming', 'dashboard protection', 'interieur', 'interior', 'leder', 'leather', 'vinyl'], four: ['trim dressing', 'bandendressing', 'plastic protection', 'kunststof', 'plastic', 'rubber', 'trim', 'dressing', 'banden', 'tyre', 'tire']
      },
      hogedrukreinigers: {
        one: ['k1050p', 'compact', 'pistoolreiniger'], two: ['k1050tst', 'tst', 'trolley'], three: ['k1050 ts', '1050 ts', 'ts '], four: ['slang', 'trigger', 'pistool', 'm22', 'kew', 'hogedruk']
      },
      'foam-cannon-accessoires': {
        one: ['adapter', 'koppeling', 'nippel', 'quick release', 'qc', 'g1/4', 'm22'], two: ['vervangfles', 'fles', 'bottle', 'wide mouth', 'pf22', 'foam cannon'], three: ['filter', 'rvs filter', 'nozzle'], four: ['karcher', 'nilfisk', 'kew', 'kranzle', 'kränzle', 'parkside', 'stihl']
      },
      'velgen-banden-accessoires': {
        one: ['velgenborstel', 'wheelbrush', 'wheel brush', 'rim brush', 'velgenkwast', 'flat wheel'], two: ['bandenborstel', 'tyre', 'tire', 'bandendressing', 'bandenzwart', 'wheel mitt'], three: ['applicator', 'pad', 'sponge', 'foam applicator', 'coating applicator'], four: ['microfiber', 'microvezel', 'washmitt', 'mitt', 'microfiber cloth', 'detailing brush', 'brush']
      },
      'reinigen-voorbereiden-accessoires': {
        one: ['foam cannon', 'foamer', 'foam lance', 'handfoamer', 'pressure foam'], two: ['brush', 'borstel', 'scrub', 'scrub pad', 'detailing brush'], three: ['clay', 'klei', 'clay towel', 'kleidoek', 'decontaminatie'], four: ['bucket', 'emmer', 'grit guard', 'dosing', 'doseerdop', 'handschoenen']
      },
      polijstaccesoires: {
        one: ['polijstpad', 'polishing pad', 'pad', 'glaspolijstpad', 'felt pad'], two: ['polijst doek', 'polish towel', 'microfiber', 'microvezel', 'towel', 'control spray', 'residue'], three: ['masking', 'afplaktape', 'ipa', 'isopropanol', 'optimizer', 'glizz'], four: ['reiniger', 'cleaner', 'brush', 'polishing machine', 'polijstmachine', 'coating']
      },
      'lakbescherming-accesoires': {
        one: ['applicator', 'applicator pad', 'sponge', 'coating applicator', 'coating sponges'], two: ['microfiber', 'microvezel', 'coatingdoek', 'microfiber roll', 'towel'], three: ['dosing', 'doseerdop', 'pipet', 'suede', 'swabs', 'foam sticks'], four: ['handschoenen', 'nitrile', 'wax', 'sealant', 'handpolijst', 'polijstpad']
      },
      'accessoires-voor-ruiten-glas': {
        one: ['glasdoek', 'glass towel', 'microvezel glas', 'streak buster', 'glass cleaning cloth'], two: ['glaco', 'coating', 'sealant', 'rain repellent', 'waterafstotend', 'ruitencoating'], three: ['glas polijst', 'polijstpasta', 'opty', 'voxer', 'felt', 'vilt', 'compound'], four: ['ruitenreiniger', 'sproeiervloeistof', 'de-icer', 'ontdooier', 'scraper', 'schraper', 'winter', 'concentraat']
      },
      'emmers-toebehoren': {
        one: ['bucket', 'emmer', 'wasemmer', 'wash bucket', 'bucket set'], two: ['grit guard', 'gritguard', 'emmerinzet', 'bucket insert', 'vuilrooster', 'vuilscheider'], three: ['organizer', 'dolly', 'deksel', 'lid', 'bucket lid', 'op wieltjes'], four: ['mitt slide', 'bucket set', 'two bucket', 'twee emmer', 'washandschoen', 'emmer accessoires']
      },
      'verstuivers-flessen': {
        one: ['sprayer', 'sprayfles', 'spraykop', 'trigger', 'sproeikop', 'fles'], two: ['foamer', 'foam dispenser', 'handfoamer', 'schuimdispenser', 'schuimsproeier', 'foam'], three: ['maatbeker', 'mengfles', 'mengbeker', 'schaalverdeling', 'dosing', 'doseerdop', 'pipet'], four: ['chemisch', 'chemical', 'acid', 'solvent', 'hdpe', 'resistant', 'multi tr', 'hc tr']
      },
      'hogedruk-koppelingen': {
        one: ['adapter', 'm22', 'g1/4', '3/8', 'connector'], two: ['quick release', 'quick connect', 'nozzle', 'nippel', 'qc', 'shower'], three: ['swivel', 'draaibare', 'slang', 'koppeling', 'draaikoppeling', 'anti knik'], four: ['karcher', 'nilfisk', 'bosch', 'parkside', 'kranzle', 'kränzle', 'stihl', 'ava']
      },
      'foam-gun-adapters': {
        one: ['karcher', 'k-series', 'koppeling'], two: ['nilfisk', 'kew', 'stihl'], three: ['m22', 'g1/4', '3/8', 'quick connect', 'nippel'], four: ['bosch', 'parkside', 'aqt', 'aquatak', 'rvs', 'messing']
      },
      'interieur-reinigen': {
        one: ['interieurreiniger', 'interior cleaner', 'all purpose cleaner', ' apc '], two: ['textiel', 'textile', 'bekleding', 'upholstery', 'carpet'], three: ['kunststof', 'plastic', 'dashboard', 'vinyl', 'trim cleaner'], four: ['leder', 'leerreiniger', 'leather', 'alcantara']
      },
      droogdoeken: {
        one: ['compact'], two: ['middelgroot'], three: ['groot', 'xl'], four: ['drooghandschoen']
      },
      microvezeldoeken: {
        one: ['allround', 'interieur'], two: ['polish', 'polijst'], three: ['coating'], four: ['glasdoek', 'glass towel']
      },
      'microvezeldoeken-droogdoeken': {
        one: ['allround', 'interieur'], two: ['polish', 'polijst'], three: ['coating'], four: ['glasdoek', 'glass towel']
      },
      'wax-sealant': {
        one: ['carnauba', 'paste wax', 'hard wax', 'harde wax'], two: ['synthetisch', 'synthetic', 'polymer sealant', 'liquid sealant', 'fusso coat', ' f7 ', 'prowax'], three: ['spraywax', 'spray wax', 'spraysealant', 'spray sealant', 'quick wax'], four: ['wet coat', 'wetcoat', 'rinse coat', 'spray on rinse off']
      },
      'washandschoenen-sponzen': {
        one: ['microvezel', 'microfibre', 'microfiber'], two: ['wol', 'wollen', 'wool', 'lambswool', 'merino'], three: ['wash pad', 'washpad'], four: ['spons', 'sponge', 'wheel mitt', 'velgenhandschoen']
      },
      'foam-cannons': {
        one: ['foam cannon', 'foam lance', 'foamlans', 'snow foam lance'], two: ['karcher', 'kärcher', 'nilfisk', 'kranzle', 'kränzle', 'ava', 'adapter'], three: ['quick connect', 'quick-connect', '1/4'], four: ['pump foamer', 'drukspuit', 'hand foamer', 'low pressure', 'lage druk']
      },
      'insecten-teer-vliegroest': {
        one: ['insect', 'bug remover', 'insekten'], two: ['teer', 'tar remover', 'adhesive', 'lijm'], three: ['vliegroest', 'iron remover', 'fallout', 'ijzer', 'remstof'], four: ['decontaminatie set', 'decontamination kit', 'clay kit', 'klei set']
      },
      'banden-reinigen': {
        one: ['bandenreiniger', 'tire cleaner', 'tyre cleaner'], two: ['banden- en velgenreiniger', 'wheel & tire', 'wheel and tire', 'velgenreiniger'], three: ['bandenborstel', 'tire brush', 'tyre brush'], four: ['banden reinigingsset', 'tire cleaning kit', 'tyre cleaning kit', 'banden set']
      },
      bandendressing: {
        one: ['satin', 'satijn', 'matte dressing', 'natural finish'], two: ['gloss', 'glans', 'high gloss', 'wet look'], three: ['trim', 'kunststof', 'rubber', 'plastic dressing'], four: ['wax', 'bandenwax', 'tire wax', 'tyre wax']
      },
      lederreiniger: {
        one: ['leerreiniger', 'leather cleaner', 'leather clean'], two: ['leer conditioner', 'lederverzorging', 'leather care', 'conditioner'], three: ['leerbeschermer', 'leather protection', 'leather sealant'], four: ['leer set', 'leather kit', 'leder set']
      },
      'kunststof-rubber-vinyl': {
        one: ['interieur kunststof', 'interior plastic', 'dashboard', 'trim'], two: ['rubberreiniger', 'rubber cleaner', 'rubber'], three: ['multi surface', 'multi-surface', 'kunststof en rubber', 'plastic & rubber'], four: ['interieurborstel', 'applicator', 'plastic accessory', 'kunststof accessoire']
      },
      multireiniger: {
        one: ['ready to use', 'ready-to-use', 'gebruiksklaar', 'apc ready'], two: ['concentraat', 'concentrate', 'apc'], three: ['interieur', 'interior', 'interieurreiniger'], four: ['specialist', 'motorruimte', 'engine bay', 'heavy duty']
      }
    };

    const exactTypes = {
      droogdoeken: { one: 'dry_compact', two: 'dry_medium', three: 'dry_large', four: 'dry_mitt' },
      microvezeldoeken: { one: 'micro_allround', two: 'micro_polish', three: 'micro_coating', four: 'micro_glass' },
      'microvezeldoeken-droogdoeken': { one: 'micro_allround', two: 'micro_polish', three: 'micro_coating', four: 'micro_glass' },
      ruitenreiniger: { one: 'glass_cleaner', two: 'glass_deep_clean', three: 'glass_protection', four: 'glass_accessory' },
      'banden-reinigen': { one: 'tire_cleaner', two: 'wheel_tire_cleaner', three: 'tire_brush', four: 'tire_cleaning_set' },
      bandendressing: { one: 'tire_dressing_satin', two: 'tire_dressing_gloss', three: 'tire_trim_dressing', four: 'tire_dressing_wax' },
      lederreiniger: { one: 'leather_cleaner', two: 'leather_care', three: 'leather_protection', four: 'leather_set' },
      'kunststof-rubber-vinyl': { one: 'plastic_interior', two: 'rubber_cleaner', three: 'multi_surface', four: 'plastic_accessory' },
      multireiniger: { one: 'apc_ready', two: 'apc_concentrate', three: 'apc_interior', four: 'apc_specialist' },
      bundels: { one: 'bundle_wash', two: 'bundle_interior', three: 'bundle_polish', four: 'bundle_specialist' },
      'borstels-kwasten': { one: 'brush_detail', two: 'brush_interior', three: 'brush_wheel', four: 'brush_specialist' },
      'hogedrukreiniger-accessoires': { one: 'pressure_adapter', two: 'pressure_gun_lance', three: 'pressure_nozzle', four: 'pressure_foam' },
      polijstpads: { one: 'pad_heavy', two: 'pad_medium', three: 'pad_finish', four: 'pad_specialist', five: 'pad_wool', six: 'pad_microfiber', seven: 'pad_foam' }
    };

    const loadNextPage = () => {
      const button = document.querySelector('[data-load-more-button]');
      if (button && !button.classList.contains('is-loading')) button.click();
    };

    const applyFilter = (topic, choice, updateUrl = true) => {
      if (!document.querySelector('[data-topic-filter-choice]')) return;
      const cards = [...document.querySelectorAll('.product-grid .product-card')];
      if (!cards.length) return;
      let visible = 0;

      cards.forEach((card) => {
        const searchText = card.dataset.topicFilterText || '';
        const filterType = card.dataset.topicFilterType || '';
        const categoryTypes = (card.dataset.topicFilterCategory || '').split(',').filter(Boolean);
        const expectedType = exactTypes[topic]?.[choice];
        const isMattePaintProduct = card.dataset.topicFilterMatte === 'true';
        const matches = choice === 'all' || (choice === 'matte' ? isMattePaintProduct : (expectedType ? filterType === expectedType || categoryTypes.includes(expectedType) : (terms[topic]?.[choice] || []).some((term) => searchText.includes(term))));
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      document.querySelectorAll(`[data-topic-filter-topic="${topic}"][data-topic-filter-choice]`).forEach((control) => {
        const active = control.dataset.topicFilterChoice === choice;
        control.setAttribute(control.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', String(active));
      });

      const count = document.querySelector('.collection-toolbar__count');
      if (count) {
        const countValue = choice === 'all' ? count.dataset.totalCount || visible : visible;
        count.textContent = (count.dataset.productCountTemplate || '__COUNT__').replace('__COUNT__', countValue);
      }
      const empty = document.querySelector('[data-topic-filter-empty]');
      if (empty) empty.hidden = visible > 0;

      if (updateUrl) {
        const url = new URL(window.location.href);
        if (choice === 'all') url.searchParams.delete('type');
        else url.searchParams.set('type', choice);
        window.history.replaceState({}, '', url);
      }
    };

    document.addEventListener('click', (event) => {
      const control = event.target.closest('[data-topic-filter-choice]');
      if (!control) return;
      event.preventDefault();
      applyFilter(control.dataset.topicFilterTopic, control.dataset.topicFilterChoice);
      if (control.dataset.topicFilterChoice !== 'all') loadNextPage();
      document.querySelector('#CollectionProducts')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    const topicControl = document.querySelector('[data-topic-filter-topic]');
    const activeTopic = topicControl?.dataset.topicFilterTopic;
    const requestedChoice = new URL(window.location.href).searchParams.get('type') || 'all';
    const initialChoice = requestedChoice === 'all' || terms[activeTopic]?.[requestedChoice] || exactTypes[activeTopic]?.[requestedChoice] ? requestedChoice : 'all';
    if (activeTopic) applyFilter(activeTopic, initialChoice, false);
    if (initialChoice !== 'all') window.setTimeout(loadNextPage, 0);

    const productGrid = document.querySelector('.product-grid');
    if (productGrid && document.querySelector('[data-topic-filter-choice]')) {
      new MutationObserver(() => {
        const activeChoice = new URL(window.location.href).searchParams.get('type') || 'all';
        if (activeTopic) applyFilter(activeTopic, activeChoice, false);
        if (activeChoice !== 'all') window.setTimeout(loadNextPage, 0);
      })
        .observe(productGrid, { childList: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-a2500"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('a2500-story')) {
    customElements.define('a2500-story', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const panels = Array.from(this.querySelectorAll('.a2500__panel'));
        const activate = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, index) => {
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].tabIndex = 0;
          tab.addEventListener('click', () => activate(index), { signal });
          tab.addEventListener('keydown', event => {
            let target = index;
            if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
            else if (event.key === 'Home') target = 0;
            else if (event.key === 'End') target = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(target, true);
          }, { signal });
        });
        this.querySelector('.a2500__tabs').hidden = false;
        activate(0);
        this.classList.add('is-ready');
        document.addEventListener('click', event => {
          if (event.target.closest('[data-review-link]')) activate(2);
        }, { signal, capture: true });
        if (location.hash === '#judgeme_product_reviews') activate(2);
        const benefits = this.querySelector('.a2500__benefits-track');
        const dots = Array.from(this.querySelectorAll('[data-benefit-index]'));
        this.querySelector('.a2500__benefit-dots').hidden = false;
        const syncBenefits = () => {
          const index = Math.round(benefits.scrollLeft / benefits.clientWidth);
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        };
        dots.forEach((dot, index) => dot.addEventListener('click', () => {
          benefits.scrollTo({ left: index * benefits.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal }));
        benefits.addEventListener('scroll', syncBenefits, { signal, passive: true });
        this.benefitObserver = new ResizeObserver(syncBenefits);
        this.benefitObserver.observe(benefits);
        const gallery = this.querySelector('.a2500__gallery');
        const controls = this.querySelector('.a2500__gallery-controls');
        const buttons = Array.from(controls.querySelectorAll('button'));
        const update = () => {
          const overflow = gallery.scrollWidth - gallery.clientWidth;
          controls.hidden = overflow < 2;
          buttons[0].disabled = gallery.scrollLeft <= 2;
          buttons[1].disabled = gallery.scrollLeft >= overflow - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          gallery.scrollBy({ left: Number(button.dataset.direction) * (gallery.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(gallery).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal }));
        gallery.addEventListener('scroll', update, { signal, passive: true });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(gallery);
        update();
        const video = this.querySelector('video');
        const toggle = this.querySelector('.a2500__video-toggle');
        if (!video) return;
        let manuallyPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const play = () => {
          if (!video.src) video.src = video.dataset.videoSrc;
          video.muted = true;
          video.play().catch(() => {});
        };
        toggle.hidden = false;
        video.addEventListener('playing', () => {
          video.setAttribute('data-playing', '');
          toggle.textContent = toggle.dataset.pause;
        }, { signal });
        video.addEventListener('pause', () => { toggle.textContent = toggle.dataset.play; }, { signal });
        toggle.addEventListener('click', () => {
          manuallyPaused = !video.paused;
          if (video.paused) play(); else video.pause();
        }, { signal });
        this.videoObserver = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && !manuallyPaused) play(); else video.pause();
        }, { threshold: .15 });
        this.videoObserver.observe(video);
      }
      disconnectedCallback() {
        this.querySelector('video')?.pause();
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.benefitObserver?.disconnect();
        this.videoObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-a4500"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('a4500-story')) {
    customElements.define('a4500-story', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const panels = Array.from(this.querySelectorAll('.a4500__panel'));
        const activate = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, index) => {
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].tabIndex = 0;
          tab.addEventListener('click', () => activate(index), { signal });
          tab.addEventListener('keydown', event => {
            let target = index;
            if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
            else if (event.key === 'Home') target = 0;
            else if (event.key === 'End') target = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(target, true);
          }, { signal });
        });
        this.querySelector('.a4500__tabs').hidden = false;
        activate(0);
        this.classList.add('is-ready');
        document.addEventListener('click', event => {
          if (event.target.closest('[data-review-link]')) activate(2);
        }, { signal, capture: true });
        if (location.hash === '#judgeme_product_reviews') activate(2);
        const benefits = this.querySelector('.a4500__benefits-track');
        const dots = Array.from(this.querySelectorAll('[data-benefit-index]'));
        this.querySelector('.a4500__benefit-dots').hidden = false;
        const syncBenefits = () => {
          const index = Math.round(benefits.scrollLeft / benefits.clientWidth);
          dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        };
        dots.forEach((dot, index) => dot.addEventListener('click', () => {
          benefits.scrollTo({ left: index * benefits.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal }));
        benefits.addEventListener('scroll', syncBenefits, { signal, passive: true });
        this.benefitObserver = new ResizeObserver(syncBenefits);
        this.benefitObserver.observe(benefits);
        const gallery = this.querySelector('.a4500__gallery');
        const controls = this.querySelector('.a4500__gallery-controls');
        const buttons = Array.from(controls.querySelectorAll('button'));
        const update = () => {
          const overflow = gallery.scrollWidth - gallery.clientWidth;
          controls.hidden = overflow < 2;
          buttons[0].disabled = gallery.scrollLeft <= 2;
          buttons[1].disabled = gallery.scrollLeft >= overflow - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          gallery.scrollBy({ left: Number(button.dataset.direction) * (gallery.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(gallery).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal }));
        gallery.addEventListener('scroll', update, { signal, passive: true });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(gallery);
        update();
        const video = this.querySelector('video');
        const toggle = this.querySelector('.a4500__video-toggle');
        if (!video) return;
        let manuallyPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const play = () => {
          if (!video.src) video.src = video.dataset.videoSrc;
          video.muted = true;
          video.play().catch(() => {});
        };
        toggle.hidden = false;
        video.addEventListener('playing', () => {
          video.setAttribute('data-playing', '');
          toggle.textContent = toggle.dataset.pause;
        }, { signal });
        video.addEventListener('pause', () => { toggle.textContent = toggle.dataset.play; }, { signal });
        toggle.addEventListener('click', () => {
          manuallyPaused = !video.paused;
          if (video.paused) play(); else video.pause();
        }, { signal });
        this.videoObserver = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && !manuallyPaused) play(); else video.pause();
        }, { threshold: .15 });
        this.videoObserver.observe(video);
      }
      disconnectedCallback() {
        this.querySelector('video')?.pause();
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.benefitObserver?.disconnect();
        this.videoObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
